import api from "./axiosConfig";

// Função para obter todas as salas
export const getSalas = async () => {
  try {
    const response = await api.get("/salas");
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar salas:", error);
    throw error;
  }
};

export const getHorariosBySalaIdAndDate = async (id, date) => {
  try {
    const response = await api.get(`/salas/${id}/horarios`, {
      params: { data: date },
    });
    return response.data.horarios;
  } catch (error) {
    console.error(`Erro ao buscar horários para a sala com ID ${id} na data ${date}:`, error);
    throw error;
  }
};

export const reservarSala = async (id, horarioId, reservador) => {
  try {
    const response = await api.patch(`/salas/${id}/horarios`, {
      horarioId,
      reservador,
    });
    return response.data;
  } catch (error) {
    console.error(`Erro ao reservar horário para a sala`);
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error("Erro ao reservar a sala. Por favor, tente novamente.");
    }
  }
};

export const downloadRelatorio = async (tipo, formato) => {
  try {
    const response = await api.get(`/report/${tipo}-report/${formato}`, {
      responseType: "blob",
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `relatorio_${tipo}.${formato === "pdf" ? "pdf" : "xlsx"}`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error(`Erro ao baixar o relatório ${tipo} no formato ${formato}:`);
    throw error;
  }
};